import { useForm as useFormHook } from "hooks";
// import useValidationSchema from "./useValidationSchema";
import type { HighRiskMerchant } from 'features/ecommerce/types';
import {
    FormField,
    type OnboardingUploadDocuments,
    type OnboardingUploadDocumentsForm
} from "./types";

export const getInitialValues = ({
    certificateOfIncorporationFileKey = null,
    memorandumAndArticlesFileKey = null,
    companyAccountBankStatementFileKey = null,
    companyFinancialStatementFileKey = null,
    bankReferenceFileKey = null,
    copyOfLicencesFileKey = null,
    proofOfDomainOwnershipFileKey = null,
    passportsOfShareholdersFileKey = null,
    utilityBillOfShareholdersFileKey = null,
    officialCompanyDocWithAuthorityFileKey = null,
    structureChartFileKey = null
}: Partial<HighRiskMerchant.OnboardingUploadDocuments>): OnboardingUploadDocuments => ({
    [FormField.CertificateOfIncorporationFileKey]: certificateOfIncorporationFileKey,
    [FormField.MemorandumAndArticlesFileKey]: memorandumAndArticlesFileKey,
    [FormField.CompanyAccountBankStatementFileKey]: companyAccountBankStatementFileKey,
    [FormField.CompanyFinancialStatementFileKey]: companyFinancialStatementFileKey,
    [FormField.BankReferenceFileKey]: bankReferenceFileKey,
    [FormField.CopyOfLicencesFileKey]: copyOfLicencesFileKey,
    [FormField.ProofOfDomainOwnershipFileKey]: proofOfDomainOwnershipFileKey,
    [FormField.PassportsOfShareholdersFileKey]: passportsOfShareholdersFileKey,
    [FormField.UtilityBillOfShareholdersFileKey]: utilityBillOfShareholdersFileKey,
    [FormField.OfficialCompanyDocWithAuthorityFileKey]: officialCompanyDocWithAuthorityFileKey,
    [FormField.StructureChartFileKey]: structureChartFileKey
});

export const useForm = (onboardingUploadDocuments: OnboardingUploadDocumentsForm) =>
    useFormHook({
        isInitialValid: false,
        ...onboardingUploadDocuments,
        validateOnMount: true,
        // validationSchema: useValidationSchema()
    });
